export const GREAT_PREVIEW_SIZE = 1020
export const SHORT_VIEW_ROWS_COUNT = 2

export const MIN_ROW_LENGTH = 3
export const MAX_ROW_LENGTH = 4

export const MAX_ASPECT_RATIO = 1.4
